var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08093 3.20312C7.38368 3.20312 7.66259 3.3673 7.80955 3.63198L8.82889 5.46815C8.96234 5.70857 8.96864 5.99936 8.84564 6.24532L7.86364 8.20936C7.86364 8.20936 8.14822 9.67245 9.33922 10.8634C10.5302 12.0544 11.9884 12.3341 11.9884 12.3341L13.9521 11.3523C14.1983 11.2292 14.4893 11.2356 14.7298 11.3693L16.5711 12.393C16.8356 12.5401 16.9996 12.8188 16.9996 13.1214V15.2353C16.9996 16.3119 15.9996 17.0894 14.9796 16.7452C12.8846 16.0383 9.63264 14.6924 7.57147 12.6312C5.51026 10.57 4.16435 7.31807 3.45746 5.22311C3.11328 4.20307 3.89082 3.20312 4.96734 3.20312H7.08093Z",
    stroke: "#B4B7B8",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.7d6d567b4bd1f1cdb8be4df66904cef7.svg";
export { ForwardRef as ReactComponent };